<template>
  <div>
    <button @click="openDialog" class="service-menu-link">
      <span class="svg-span" v-html="menuInfo.icon"></span>
      <span class="link-name">{{ menuInfo.name }}</span>
    </button>
    <HUDDialog
      v-if="isDialogOpened"
      :isAdmin="isAdmin"
      @close-dialog="closeDialog"
      @confirm-dialog="redirectToPlusApp"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HUDDialog from '@/components/Menu/Payzon/HUDDialog.vue';

export default {
  name: 'PayzonMenuItem.vue',
  components: { HUDDialog },
  data() {
    return {
      isDialogOpened: false,
    };
  },
  props: {
    menuInfo: {
      type: Object,
      default: () => {
        return { menu_type: 'PAYZON_LINK', icon: '', name: '' };
      },
    },
  },
  computed: {
    ...mapState({
      isAdmin: (state) => state.cache.userInfo.level === 'admin',
      plusAppInfo: (state) => state.menu.menuInfoList.find((menu) => menu.menu_type === 'STORE_LINK'),
    }),
  },
  methods: {
    openDialog() {
      this.isDialogOpened = true;
    },
    closeDialog() {
      this.isDialogOpened = false;
    },
    redirectToPlusApp() {
      this.isDialogOpened = false;
      const url = this.getUrlByMenuInfo(this.plusAppInfo) + 'detail?app_id=5';
      window.location.assign(url);
    },
    getUrlByMenuInfo(menuInfo) {
      if (menuInfo.is_include_domain) {
        return menuInfo.sub_domain + '/' + menuInfo.domain + menuInfo.url;
      }
      return menuInfo.sub_domain + menuInfo.url;
    },
  },
};
</script>

<style lang="scss" scoped>
.service-menu-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (min-width: 900px) {
    max-height: 240px;
  }
  .service-menu-link-wrap {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-basis: 50%;
    max-width: 50%;
    // min-width: 156px;
    // max-width: 156px;
    height: 40px;
    padding-left: 8px;
    flex-grow: 1;
    .service-menu-link {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 1.79;
      color: #333;
      overflow: hidden;
      flex-grow: 1;
      height: 100%;
      .svg-span {
        display: flex;
        align-items: center;
        box-sizing: content-box;
      }
      .link-name {
        margin-left: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &:hover {
      background: #eff4fc;
      ::v-deep .svg-hover-color {
        fill: #4e9bd4;
      }
      .service-menu-link {
        color: #2985db;
      }
    }
  }
}
</style>
